
import {String_Validate_Password} from "../../../../h5_src/utils/classes/string/Validate.Password";

export class GC_Valid_T_Password {

    protected min = 6;
    protected max = 18;

    constructor(opt) {
        this.min        = opt && opt.min || this.min;
        this.max        = opt && opt.max || this.max;
    }

    public validate(variable) {
        return  String_Validate_Password.testByWidth(variable, this.min, this.max);
    }

}
